import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { colors } from '../styles/theme';

const AuthLayout: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: colors.beige,
      }}
    >
      <Outlet />
    </Box>
  );
};

export default AuthLayout;
